import { render } from "./App.vue?vue&type=template&id=77d89aa1"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=77d89aa1&lang=css"

import exportComponent from "/home/avatar_milano_chat/avatar.chat.web/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__